/**************************************************
 * Nombre:       Formulario_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    CloudDownload,
    Flag,
    FlagOutlined,
    LocalShippingOutlined,
    Mail,
    MapsHomeWorkOutlined,
    MoneyOutlined,
    PictureAsPdf,
    SignpostOutlined,
    SmartphoneOutlined,
    WalletOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Pedido from "./Formulario_Producto_Pedido";
import Tarjetas_Producto from "../Tarjeta/Tarjetas_Producto";
import {useEffect, useState} from "react";
import {obtenerTotal} from "../../CodNegocio/obtenerTotal";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {ESTADOPEDIDO, ESTADOSPEDIDOS} from "../../Constantes";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {obtenerDatosTransaccion} from "../../Modulo_Wompi_Adentro/Funciones/obtenerDatosTransaccion";
import {generarGuia} from "../../Modulo_Envios_2026/Funciones/generarGuia";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {irUrl} from "../../Utilidades/irUrl";
import {obtenerEstadoPago} from "../../Modulo_Mercado_Pago/Funciones/obtenerEstadoPago";
import {solicitarMensajeGuia} from "../../Modulo_Envios_2026/solicitarMensajeGuia";

const Formulario_Pedido = ({...props}) => {
    const {Cargador, Avisos, terminar, iniciarCarga, nuevoAviso} = useCargador({logoRedondo: logo, funcionUno: props.guardar})
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'productos',
        Formulario: Formulario_Producto_Pedido,
        nombre: 'Actualizar',
        Tarjeta: Tarjetas_Producto
    })
    const [valor, setValor] = useState(0)
    const [valorEnvio, setValorEnvio] = useState(0)
    const [cargando, setCargando] = useState(false)
    const [resultado, setResultado] = useState('')


    const verificarPago = async () => {

        let datos = props.props.getValues()
        setCargando(true)
        if (datos.pasarela === 'Wompi') {
            let dox = await obtenerDatosTransaccion(datos.idTransaccion)
            if (dox) {
                setResultado(`${dox.status} - ${formatoMonedaTabla(dox.amount_in_cents / 100)}`)
            }
        } else {
            let dox = await obtenerEstadoPago({idPago: datos.idTransaccion})

            if (dox) {
                setResultado(`${dox.status} - ${formatoMonedaTabla(dox.transaction_amount)}`)
            }
        }

        setCargando(false)

    }

    const realizarGuia = async () => {

        let datos = props.props.getValues()

        if (datos.linkGuia) {
            irUrl(datos.linkGuia);
        } else {

            iniciarCarga('Generando Guia')
            let dox = await generarGuia({pedido: datos})
            if (dox.res) {
                //guardamos link de guia
                props.props.setValue('linkGuia', dox.data.url)
                //Enviar num de Guia a usuario

                terminar({aviso: 'Guia creada, se guardaran los datos'})


            } else {
                terminar({aviso: 'No se puede generar la guia', variante: 'error'})
            }

        }


    }

    const enviarGuia = () => {

        let datos = props.props.getValues()
        if ((datos.estado === 'Empaquetando' || datos.estado === 'Enviado') && datos.linkGuia &&
            (datos.estadoPago === 'approved' || datos.estadoPago === 'APPROVED')) {
            solicitarMensajeGuia({pedido: {idPedido: datos.id, estadoPago: datos.estadoPago}})
            nuevoAviso({aviso: `Guia enviada medinte SMS al numero: ${datos.celular}`})
        } else {
            terminar({aviso: 'Solo se puede enviar link de guia a pedidos Empaquetados o Enviados y estado de pago approved'})
        }

    }


    useEffect(() => {


        let entidad = props.props.getValues()
        let productos = props.props.getValues('productos')
        let val = obtenerTotal(productos)
        if (val) {
            setValor(val)
        }
        setValorEnvio(entidad.valorEnvio)

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Cargador/>

                <Avisos/>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOPEDIDO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-end', alignItems: 'center'}}
                      spacing={0}
                >
                    <Typography
                        sx={{fontSize: 14, fontWeight: 800}}>{`Valor Pedido: ${formatoMonedaTabla(valor)}`}</Typography>
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600
                        }}>{`Valor Envio: ${formatoMonedaTabla(valorEnvio)}`}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Cliente</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificación'} dato={'cc'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Productos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de Pago</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={WalletOutlined} nombre={'Pasarela'}
                                  dato={'pasarela'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor Pagado'}
                                   dato={'valorPagado'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Estado Pago'}
                                  dato={'estadoPago'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Metodo Pago'}
                                  dato={'metodo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto editable={false} nombre={'Id Transaccion'}
                                  dato={'idTransaccion'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={2} nombre={'Mensaje de Pago'}
                                  dato={'mensaje'} {...props}
                    />
                </Grid>

                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <Typography>{resultado}</Typography>
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button loading={cargando} onClick={() => verificarPago()} variant={'outlined'}>Verificar
                        Pago</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto nombre={'Id Envio'}
                                  dato={'idEnvio'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LocalShippingOutlined} nombre={'Empresa Envio'}
                                  dato={'empresaEnvio'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Ciudad'}
                                  dato={'ciudad'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Departamento'}
                                  dato={'departamento'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Barrio o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Dirección'} dato={'direccion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones adiciónales'} dato={'indicaciones'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTextoBoton IconoFinal={props.props.getValues('linkGuia') ? PictureAsPdf : CloudDownload}
                                       nombre={'Link Guia'}
                                       dato={'linkGuia'} {...props} click={realizarGuia} editable={false}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Button onClick={() => enviarGuia()} variant={'outlined'}>Enviar Guia</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Notas Internas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'} dato={'notas'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pedido